import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  featherAlertCircle,
  featherCheckCircle,
  featherX,
  featherXCircle,
} from '@ng-icons/feather-icons';
import { timer } from 'rxjs';

export type ToastVariant = 'danger' | 'warning' | 'success';

interface ToastConfig {
  wrapperClasses: string;
  color: string;
  icon: string;
}

const VARIANT_CONFIG: Record<ToastVariant, ToastConfig> = {
  danger: {
    wrapperClasses: 'bg-danger-25 border border-danger-50',
    color: 'var(--color-danger-100)',
    icon: 'featherXCircle',
  },
  warning: {
    wrapperClasses: 'bg-warning-25 border border-warning-50',
    color: 'var(--color-warning-100)',
    icon: 'featherAlertCircle',
  },
  success: {
    wrapperClasses: 'bg-success-25 border border-success-50',
    color: 'var(--color-success-100)',
    icon: 'featherCheckCircle',
  },
};

@Component({
  selector: 'dialab-toast',
  imports: [NgIcon],
  viewProviders: [
    provideIcons({ featherXCircle, featherAlertCircle, featherCheckCircle, featherX }),
  ],
  templateUrl: './toast.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast implements OnInit {
  readonly message = input.required<string>();
  readonly variant = input.required<ToastVariant>();
  readonly duration = input<number>(5000);
  readonly showCloseButton = input<boolean>(true);

  readonly closed = output<void>();

  private readonly destroyRef = inject(DestroyRef);

  protected readonly config = computed(() => VARIANT_CONFIG[this.variant()]);

  ngOnInit(): void {
    timer(this.duration())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.closed.emit());
  }
}
